import script from "./footerVue.vue?vue&type=script&setup=true&lang=js"
export * from "./footerVue.vue?vue&type=script&setup=true&lang=js"

import "./footerVue.vue?vue&type=style&index=0&id=744f5082&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744f5082"]])

export default __exports__